import { useTranslation } from 'react-i18next';
import { useReveal } from '../../hooks/useReveal';

export default function StatsStrip() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.07 });
  const stats = t('home.stats.items', { returnObjects: true });

  return (
    <section
      ref={ref}
      className="section-sm"
      style={{ background: 'var(--p2a-dark-bg)', borderBottom: '1px solid var(--p2a-dark-border)' }}
    >
      <div className="p2-container">
        <div
          className="mono reveal"
          style={{
            fontSize: 11, letterSpacing: '0.14em', color: 'var(--p2a-dark-fg-4)',
            marginBottom: 32,
            display: 'flex', alignItems: 'center', gap: 10,
          }}
        >
          <span style={{ width: 24, height: 1, background: 'var(--p2a-green-500)' }} />
          {t('home.stats.label')}
        </div>
        <div
          className="stats-grid"
          style={{
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
            borderTop: '1px solid var(--p2a-dark-border)',
            borderLeft: '1px solid var(--p2a-dark-border)',
          }}
        >
          {stats.map((s, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                padding: '40px 28px',
                borderRight: '1px solid var(--p2a-dark-border)',
                borderBottom: '1px solid var(--p2a-dark-border)',
              }}
            >
              <div className="mono" style={{
                fontSize: 'clamp(32px, 4.2vw, 56px)',
                lineHeight: 1,
                fontWeight: 600,
                letterSpacing: '-0.03em',
                color: 'var(--p2a-dark-fg-1)',
                fontVariantNumeric: 'tabular-nums',
              }}>
                {s.v}<span style={{ color: 'var(--p2a-green-400)', marginLeft: 2 }}>{s.u}</span>
              </div>
              <div style={{ marginTop: 16, fontSize: 13, color: 'var(--p2a-dark-fg-3)', maxWidth: 180, lineHeight: 1.35 }}>
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 560px) {
          .stats-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
